// time should be a string in "hh:mm" format
export const getUTCdate = (time) => {
  const date = new Date();
  date.setUTCHours(time.split(':')[0], time.split(':')[1], 0);
  return date.toISOString().slice(0, -1)
};
